import { motion } from "framer-motion";
import Link from "next/link";
import { useState } from "react";
import useAuth from "../../../lib/use/useAuth";
import BurgerMenu from "../menu/BurgerMenu";
import Menu from "../menu/Menu";
import styles from "./index.module.css";

const Header = ({ setPageNumber, isHome = true }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isAuth] = useAuth();
  return (
    <>
      {!isHome ? null : (
        <Menu
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          setPageNumber={setPageNumber}
        />
      )}
      <header className={styles.headerContainer}>
        {isHome ? (
          <motion.div
            layoutId="menu-icon"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.5 }}
          >
            <BurgerMenu isOpen={isOpen} setIsOpen={setIsOpen} />
          </motion.div>
        ) : (
          <motion.div
            layoutId="menu-icon"
            animate={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: -10 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.5 }}
          >
            <Link href="/">
              <span className="backBtn"></span>
            </Link>
          </motion.div>
        )}

        <motion.span animate={{ opacity: 1, y: 0 }}
                     initial={{ opacity: 0, y: -10 }}
                     exit={{ opacity: 0, y: 10 }}
                     transition={{ delay: 0.2, duration: 0.5 }}
        >
          Axel Godefroy{" "}
          {isAuth ? <small style={{ opacity: 0.5 }}>(Admin)</small> : null}
        </motion.span>
      </header>
    </>
  );
};

export default Header;
